import React from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, UserOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, DatePicker, Select, Table, Space, Button, Modal, Tooltip } from "antd";
import "./item_wh_transfer_request.css";
import useItemWHTransferRequestLogic from "../../components/hoc_item_wh_transfer_request";
import AddLineWhTransferRequest from "./add_line_wh_transfer_request";
import EditTableWhTransferRequest from "./edit_table_wh_transfer_request";
import { useAuth } from "../../context/AuthContext";

const ItemWHTransferRequest: React.FC = () => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    const { userData } = useAuth();
    const {
        form,
        onDateChange,
        onChange,
        onWarehouseOriginChange,
        columns,
        rowSelection,
        getSelectPopupContainer,
        warehouses,
        isAddLineModalVisible,
        showAddLineModal,
        handleCancelAddLineModal,
        originWarehouse,
        dataSource,
        handleAddLine,
        handleDelete,
        isEditModalVisible,
        editingItem,
        showEditModal,
        handleCancelEditModal,
        handleSaveEditedItem,
        autosaveStatus,
        handleFormValuesChange,
        handleSubmit,
        handleVoid,
        isFormDisabled,
        isReceiptMode,
        handleAccept,
        handleReject,
        isAcceptRejectDisabled,
        handleNew,
    } = useItemWHTransferRequestLogic(userData);
    const status = Form.useWatch('status', form);

    return (

        <div id="iau9" style={transformStyle}>
            <div className="gjs-grid-row" id="ilpat">
                <div className="gjs-grid-column" id="i8oee">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/data_wh_transfer_request",
                                title: (
                                    <>
                                        <span>Data WH Transfer Request</span>
                                    </>
                                ),
                            },
                            {
                                title: "Item WH Transfer Request",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="xxas3s">
                <div className="gjs-grid-column" id="dh8asj">
                    <Button className="gr-button" onClick={handleNew}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V12Z"
                                clipRule="evenodd"
                            />
                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                        </svg>
                        New
                    </Button>
                    <Button className="gr-button" onClick={handleSubmit} disabled={isFormDisabled}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                clipRule="evenodd"
                            />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg>
                        Submit
                    </Button>
                    <Button className="gr-button" onClick={handleVoid} disabled={isFormDisabled}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}> // ✅: add void icon svg
                            <path fillRule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z" clipRule="evenodd" /> // ✅: trash icon path
                        </svg> 
                        Void 
                    </Button> 
                    <Button className="gr-button" >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M7.875 1.5C6.839 1.5 6 2.34 6 3.375v2.99c-.426.053-.851.11-1.274.174-1.454.218-2.476 1.483-2.476 2.917v6.294a3 3 0 0 0 3 3h.27l-.155 1.705A1.875 1.875 0 0 0 7.232 22.5h9.536a1.875 1.875 0 0 0 1.867-2.045l-.155-1.705h.27a3 3 0 0 0 3-3V9.456c0-1.434-1.022-2.7-2.476-2.917A48.716 48.716 0 0 0 18 6.366V3.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM16.5 6.205v-2.83A.375.375 0 0 0 16.125 3h-8.25a.375.375 0 0 0-.375.375v2.83a49.353 49.353 0 0 1 9 0Zm-.217 8.265c.178.018.317.16.333.337l.526 5.784a.375.375 0 0 1-.374.409H7.232a.375.375 0 0 1-.374-.409l.526-5.784a.373.373 0 0 1 .333-.337 41.741 41.741 0 0 1 8.566 0Zm.967-3.97a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H18a.75.75 0 0 1-.75-.75V10.5ZM15 9.75a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V10.5a.75.75 0 0 0-.75-.75H15Z"
                                clipRule="evenodd"
                            />
                        </svg>
                        Print
                    </Button>
                    <Space style={{ marginLeft: '10px' }}>
                        {autosaveStatus === 'processing' && (
                            <Tooltip title="Autosave sedang berjalan...">
                                <LoadingOutlined style={{ color: '#1890ff' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'error' && (
                            <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                <WarningOutlined style={{ color: '#ff4d4f' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'stopped' && (
                            <Tooltip title="Autosave Stopped">
                                <StopOutlined style={{ color: '#bfbfbf' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'idle' && (
                            <Tooltip title="Autosave berhasil.">
                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            </Tooltip>
                        )}
                    </Space>
                </div>
            </div>
            <div className="gjs-grid-row" id="i8wrj">
                <div className="gjs-grid-column" id="i1rvj">

                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '180px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        onValuesChange={handleFormValuesChange}
                    >
                        <Form.Item
                            label="Created"
                            name="created"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly disabled={isFormDisabled} />
                            {/*  */}
                        </Form.Item>
                        <Form.Item
                            label="Transfer Request Status"
                            name="status"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly disabled={isFormDisabled} />
                            {/*  */}
                        </Form.Item>
                        <Form.Item
                            label="Transfer Request No"
                            name="transfer_request_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly disabled={isFormDisabled} />
                            {/*  */}
                        </Form.Item>
                        <Form.Item
                            label="Transfer Request Date"
                            name="transfer_request_date"
                            style={{
                                marginBottom: "5px",
                            }}


                        >
                            <DatePicker
                                onChange={onDateChange}
                                format="DD/MM/YYYY"
                                placeholder="Date"
                                style={{ width: "60%", fontSize: "14px" }}
                                popupStyle={{ fontSize: "12px" }}
                                disabled={isFormDisabled}
                                readOnly
                            />
                        </Form.Item>
                        <div className="grid2">
                            <label style={{ fontWeight: 600 }}> Request From (Origin) </label>
                            <Form.Item
                                label="Warehouse"
                                name="warehouse_origin"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('warehouse_destination') !== value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Warehouse sama, tidak boleh!'));
                                        },
                                    }),
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}

                            >
                                <Select
                                    showSearch
                                    placeholder="Warehouse"
                                    optionFilterProp="label"
                                    onChange={onWarehouseOriginChange}
                                    options={[
                                        { value: "", label: "-- Empty --" },
                                        ...warehouses.map(wh => ({
                                            value: wh.warehouse_code,
                                            label: wh.warehouse_name
                                        }))
                                    ]}
                                    style={{ width: "100%" }}
                                    getPopupContainer={getSelectPopupContainer}
                                    disabled={isFormDisabled || !!originWarehouse} 
                                />
                            </Form.Item>
                        </div>

                        <div className="grid2">
                            <label style={{ fontWeight: 600 }}> Request To (Destination) </label>
                            <Form.Item
                                label="Warehouse"
                                name="warehouse_destination"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('warehouse_origin') !== value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Warehouse sama, tidak boleh!'));
                                        },
                                    }),
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Warehouse"
                                    optionFilterProp="label"
                                    onChange={onChange}
                                    options={[
                                        { value: "", label: "-- Empty --" },
                                        ...warehouses.map(wh => ({
                                            value: wh.warehouse_code,
                                            label: wh.warehouse_name
                                        }))
                                    ]}
                                    style={{ width: "100%" }}
                                    getPopupContainer={getSelectPopupContainer}
                                    disabled={isFormDisabled}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Purpose"
                                name="purpose"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input.TextArea rows={4} placeholder="Enter your Purpose here..." disabled={isFormDisabled} />
                                {/*  */}
                            </Form.Item>
                        </div>

                        <div className="grid2">
                            <label style={{ fontWeight: 600 }}> Approval </label>
                            <Form.Item
                                label="Approval Date"
                                name="approval_date"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly disabled={isFormDisabled} />
                                {/*  */}
                            </Form.Item>
                            <Form.Item
                                label="Remark"
                                name="remark"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={isReceiptMode && status === 'Ready' ? [{ required: true, message: 'Remark is required to accept!' }] : []}
                            >
                                 <Input.TextArea rows={4} placeholder="Enter your Remark here..." disabled={!(isReceiptMode && status === 'Ready')} />
                            </Form.Item>
                        </div>

                    </Form>

                </div>
            </div>

            <div className="gjs-grid-row" id="iv5n9">
                <div className="gjs-grid-column" id="itybu">
                    <Table<any>
                        rowSelection={rowSelection}
                        columns={columns}
                        dataSource={dataSource}
                        scroll={{ x: 900 }}
                        onRow={(record) => {
                            return {
                                onDoubleClick: () => {
                                    if (!isFormDisabled) {
                                        showEditModal(record);
                                    }
                                },
                            };
                        }}
                    />
                    <div style={{ marginTop: "20px", textAlign: "left" }}>
                        <Space>
                            {isReceiptMode ? (
                                <>
                                    <Button
                                        type="primary"
                                        onClick={handleAccept}
                                        style={{
                                            height: "40px",
                                            width: "105px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: "#52c41a",
                                        }}
                                        disabled={isAcceptRejectDisabled}
                                    >
                                        Accept
                                    </Button>
                                    <Button
                                        type="primary"
                                        danger
                                        onClick={handleReject}
                                        style={{
                                            height: "40px",
                                            width: "90px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                        disabled={isAcceptRejectDisabled}
                                    >
                                        Reject
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Button
                                        type="primary"
                                        id="add_line_wh_transfer_request"
                                        onClick={showAddLineModal}
                                        style={{
                                            height: "40px",
                                            width: "105px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                        icon={
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                style={{ width: "22px", height: "22px" }}
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        }
                                        disabled={isFormDisabled}
                                    >
                                        Add Line
                                    </Button>
                                    <Button
                                        type="primary"
                                        onClick={handleDelete}
                                        style={{
                                            height: "40px",
                                            width: "90px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                        icon={
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                style={{ width: "22px", height: "22px" }}
                                            >
                                                <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clipRule="evenodd" />
                                            </svg>
                                        }
                                        disabled={isFormDisabled}
                                    >
                                        Delete
                                    </Button>
                                </>
                            )}
                        </Space>
                    </div>
                </div>
            </div>
            <Modal
                title="Add Item"
                className="add_line_wh_transfer_request"
                open={isAddLineModalVisible}
                onCancel={handleCancelAddLineModal}
                footer={null}
                width={900}
                destroyOnClose
            >
                <AddLineWhTransferRequest
                    originWarehouse={originWarehouse}
                    onOk={handleAddLine}
                    onCancel={handleCancelAddLineModal}
                />
            </Modal>
            <Modal
                title="Edit Item Quantity"
                className="edit_table_wh_transfer_request"
                open={isEditModalVisible}
                onCancel={handleCancelEditModal}
                footer={null}
                width={400}
                destroyOnClose
            >
                {editingItem && (
                    <EditTableWhTransferRequest
                        item={editingItem}
                        onSave={handleSaveEditedItem}
                        onCancel={handleCancelEditModal}
                    />
                )}
            </Modal>
        </div>
    );
};

export default ItemWHTransferRequest;